import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Router, useRouter } from 'shared-routing';

import { Routes } from '@common/constants';
import { getToken } from '@utils/auth';
import { logout } from '@store/guest/actions';
import { guestSelectors } from '@store/guest/selectors';

export const getSafeRedirect = (redirectTo: unknown): string => {
  const path = typeof redirectTo === 'string' ? redirectTo : '';
  return path.startsWith('/') && !path.startsWith('//') ? path : Routes.HOME;
};

export const useSignInSession = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const guest = useSelector(guestSelectors.getGuest) as { id?: number } | null;
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    if (guest?.id && getToken()) {
      Router.replace(getSafeRedirect(router.query.redirectTo));
      return;
    }

    dispatch(logout());
  }, [dispatch, guest, router.query.redirectTo]);
};
